import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import './i18n/config';
import './index.css';
import App from './App.tsx';
import { CACHE_TIME, TOAST_DURATION } from './types/constants';
import { RefreshProvider } from './contexts/RefreshContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: CACHE_TIME.DEFAULT,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <QueryClientProvider client={queryClient}>
        <RefreshProvider>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: TOAST_DURATION.DEFAULT,
              style: {
                background: 'var(--color-neutral-800)',
                color: 'var(--color-brand-white)',
              },
              success: {
                style: {
                  background: 'var(--color-success-500)',
                  color: 'var(--color-brand-white)',
                },
              },
              error: {
                style: {
                  background: 'var(--color-error-500)',
                  color: 'var(--color-brand-white)',
                },
              },
            }}
          />
        </RefreshProvider>
      </QueryClientProvider>
    </Suspense>
  </StrictMode>,
);
